import * as React from 'react';
import { Tooltip } from '../tooltip/tooltip';
import { InfoIcon } from '../../icons/icons-components/info';
import { namespacedClassnames } from '../../common/namespace-classes';
import { alertIndicationOrangeLarge, alertRound } from '../../icons/processed';
import { Icon } from '../icon/icon';
var getIcon = function (type) {
    if (type === void 0) { type = 'info'; }
    switch (type) {
        case 'warning':
            return React.createElement(Icon, { icon: alertRound });
        case 'attention':
            return React.createElement(Icon, { icon: alertIndicationOrangeLarge });
        default:
            return React.createElement(InfoIcon, null);
    }
};
export var InfoTooltip = function (props) {
    var infoTooltipTriggerClassName = namespacedClassnames('info-tooltip', props.className);
    var tooltipIcon = getIcon(props.type);
    return (React.createElement(Tooltip, { body: props.text, relativeToBody: props.relativeToBody, className: infoTooltipTriggerClassName, align: props.tooltipAlign, forceHidden: props.forceHidden, forceVisible: props.forceVisible, direction: props.direction }, tooltipIcon));
};
//# sourceMappingURL=info-tooltip.js.map